import {
  Actions,
  Chip,
  ChipIconWrapper,
  ChipIconPencil,
  TruncateAndTooltip,
  Flex,
  FlexItem,
  Title,
  TITLE_VARIANT_M,
  Text,
  TEXT_VARIANT_BOLD,
  TEXT_VARIANT_LIGHT,
  SkeletonLoader,
  SKELETON_LOADER_VARIANT_ONWHITE,
  Grid,
  GridCell
} from 'mailup-web-components'
import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import ReactTooltip from 'react-tooltip'
import { previewState } from '../../recoil/state/preview'
import { useRecoilValue } from 'recoil'
import { useLocation } from 'react-router-dom'
import qs from 'qs'

const Head = ({
  id,
  title,
  notes,
  email,
  actionItems,
  tooltip,
  showCallback
}) => {
  const intl = useIntl()
  const { hasPersonalization } = useRecoilValue(previewState)
  const { search } = useLocation()
  const qsParams = qs.parse(
    search.startsWith('?') ? search.substring(1) : search
  )

  const hideAction = qsParams.source === 'newtab'

  const { loading } = useRecoilValue(previewState)

  if (loading && !title) {
    return (
      <>
        <Flex flexDirection='column' justifyContent='flex-start'>
          <FlexItem>
            <SkeletonLoader
              variant={SKELETON_LOADER_VARIANT_ONWHITE}
              width='300px'
              height='18px'
            />
            <SkeletonLoader
              variant={SKELETON_LOADER_VARIANT_ONWHITE}
              width='300px'
              height='14px'
            />
          </FlexItem>
          {hasPersonalization && (
            <FlexItem>
              <Flex flexDirection='row'>
                <FlexItem margin='0 8px 0 0' padding='0 0 8px 0'>
                  <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
                    {intl.formatMessage({
                      id: 'Load.PreviewViewer.ReferenceRecipient'
                    })}
                  </Text>
                </FlexItem>
                <SkeletonLoader
                  variant={SKELETON_LOADER_VARIANT_ONWHITE}
                  width='100px'
                  height='14px'
                />
              </Flex>
            </FlexItem>
          )}
          {actionItems.length > 0 && !hideAction && (
            <FlexItem>
              <Actions disabled items={actionItems} className='test-actions' />
            </FlexItem>
          )}
        </Flex>
      </>
    )
  }

  return (
    <>
      <Grid cols={12}>
        <GridCell span={actionItems.length > 0 && !hideAction ? 11 : 12}>
          <Flex flexDirection='column'>
            <Title variant={TITLE_VARIANT_M}>
              <TruncateAndTooltip text={title} />
            </Title>
            <FlexItem margin='0 0 8px 0'>
              <Text variant={TEXT_VARIANT_LIGHT}>
                {id}
                {notes && ` - ${notes}`}
              </Text>
            </FlexItem>
            {hasPersonalization && (
              <FlexItem>
                <Flex flexDirection='row' alignItems='baseline'>
                  <FlexItem margin='0 8px 0 0' padding='0 0 8px 0'>
                    <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
                      {intl.formatMessage({
                        id: 'Load.PreviewViewer.ReferenceRecipient'
                      })}
                    </Text>
                  </FlexItem>
                  {email ? (
                    <>
                      {tooltip && (
                        <ReactTooltip
                          id='test'
                          type='light'
                          effect='solid'
                          className='c-tooltip'
                        >
                          {tooltip}
                        </ReactTooltip>
                      )}
                      <span data-tip data-for='test'>
                        <Chip label={email}>
                          <ChipIconWrapper onClick={showCallback}>
                            <ChipIconPencil />
                          </ChipIconWrapper>
                        </Chip>
                      </span>
                    </>
                  ) : (
                    <Text htmlElement='span'>
                      {intl.formatMessage({
                        id: 'Load.PreviewViewer.ToDefine'
                      })}
                    </Text>
                  )}
                </Flex>
              </FlexItem>
            )}
          </Flex>
        </GridCell>
        {actionItems.length > 0 && !hideAction && (
          <GridCell span={1}>
            <Actions items={actionItems} className='test-actions' />
          </GridCell>
        )}
      </Grid>
    </>
  )
}

export default Head

Head.defaultProps = {
  actionItems: []
}

Head.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  notes: PropTypes.string,
  email: PropTypes.string,
  actionItems: PropTypes.arrayOf(PropTypes.object),
  tooltip: PropTypes.any,
  showCallback: PropTypes.func
}
